var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-big-screen[data-v-06e75b9a] {\n  position: relative;\n  width: 96vw;\n  height: -webkit-calc(100vh - 80px);\n  height: calc(100vh - 80px);\n  background: url(" + escape(require("@/assets/schoolDataScreenbg.png")) + ") no-repeat center center;\n  background-size: cover;\n}\n.data-big-screen .skip-btn[data-v-06e75b9a] {\n  position: absolute;\n  top: 50%;\n  left: 130px;\n  width: 200px;\n  height: 42px;\n  font-size: 16px;\n}\n", ""]);

// exports
